"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Box = _interopRequireDefault(require("../Box"));
var _classnames = _interopRequireDefault(require("../Dialog/classnames"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var MAX_SIZE = '150px';
var DialogIllustration = function DialogIllustration(_ref) {
  var src = _ref.src,
    alt = _ref.alt;
  return /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    className: _classnames["default"].DIALOG_ILLUSTRATION,
    display: "flex",
    justifyContent: "center"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    width: MAX_SIZE,
    src: src,
    alt: alt
  }));
};
DialogIllustration.propTypes = process.env.NODE_ENV !== "production" ? {
  src: _propTypes["default"].string.isRequired,
  alt: _propTypes["default"].string
} : {};
DialogIllustration.defaultProps = {
  alt: ''
};
var _default = exports["default"] = DialogIllustration;